import { AdminMessage } from "@components/atoms/AdminMessage"
import { cn } from "@utils/tw"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Spacer",
  tags: ["#page", "#inline"],
}

export default defineBlock("section/spacer", (props) => {
  return (
    <div
      className={cn(
        "spacer w-full h-0 relative overflow-hidden -mb-9",
        env.admin && "bg-[#f3f3f3] border-dashed border-current border mb-0 overflow-visible",
        props.size === "-10" && "-mt-10",
        props.size === "-9" && "-mt-9",
        props.size === "-8" && "-mt-8",
        props.size === "-7" && "-mt-7",
        props.size === "-6" && "-mt-6",
        props.size === "-5" && "-mt-5",
        props.size === "-4" && "-mt-4",
        props.size === "-3" && "-mt-3",
        props.size === "-2" && "-mt-2",
        props.size === "-1" && "-mt-1",
        props.size === "1" && "h-1",
        props.size === "2" && "h-2",
        props.size === "3" && "h-3",
        props.size === "4" && "h-4",
        props.size === "5" && "h-5",
        props.size === "6" && "h-6",
        props.size === "7" && "h-7",
        props.size === "8" && "h-8",
        props.size === "9" && "h-9",
        props.size === "10" && "h-10",
      )}
    >
      {env.admin && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xs text-gray-500 font-mono uppercase">
          SPACER {props.size} (Adjust size in the side panel)
        </div>
      )}
    </div>
  )
})
